package com.essntl.features.service.data.supabase.extraservice

import com.essntl.features.service.data.supabase.service.ServiceDto
import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class ExtraServiceDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("service_id_data")
    val service: ServiceDto,
    @SerialName("updated_by")
    val updatedBy: String?,
    val description: String?,
    @SerialName("unit_price")
    val unitPrice: Int?,
    val quantity: Int?,
) {
    fun toModel(): ExtraServiceModel =
        ExtraServiceModel(
            id = id,
            createdAt = createdAt,
            service = service.toModel(),
            updatedBy = updatedBy,
            description = description,
            unitPrice = unitPrice,
            quantity = quantity,
        )

    companion object {
        fun getColumns() = Columns.raw("*, service_id_data:service_id(${ServiceDto.COLUMNS_VALUE})")
    }
}
